import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMap, Source, Layer } from "react-map-gl";
import * as turf from "@turf/turf";

const HandleFeatureHover = ({ feature }) => {
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();
  const cur_hover_id = useSelector((state) => state.inputs.cur_hover_id);

  useEffect(() => {
    map.triggerRepaint();
  }, [cur_hover_id]);

  if (cur_hover_id !== feature.properties.index) return null;

  const outlineColor = feature.properties.identity === 0 ? "#FFFFFF" : feature.properties.identity === 1 ? "#ff0000" : feature.properties.identity === 2 ? "#ffff00" : "#FFFFFF";

  return (
    <Source
      type="geojson"
      key={feature.properties.index}
      data={{
        type: "FeatureCollection",
        features: [feature],
      }}
    >
      <Layer
        id={`hover-fill-${feature.properties.index}`}
        type="fill"
        paint={{
          "fill-color": "#00d5e7",
          "fill-opacity": 0.5,
          "fill-outline-color": outlineColor,
        }}
      />
    </Source>
  );
};

const ShadeObjectHover = ({ obj }) => {
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();

  let highlight_color = "#00d5e7";

  const shade_marker_pos = useSelector((state) => state.canopy.shade_marker_pos);

  useEffect(() => {
    map.triggerRepaint();
  }, [shade_marker_pos]);

  return (
    <>
      {shade_marker_pos === obj.id && (
        <Source
          type="geojson"
          key={`${obj.id}_shadeHover`}
          data={obj.shape === "tree" ? turf.circle(obj.geoJson.geometry.coordinates[0][0], obj.geoJson.properties.circleRadius, { steps: 64 }) : obj.geoJson}
        >
          {obj.shape === "treeLine" ? (
            <Layer
              type="line"
              paint={{
                "line-color": highlight_color,
              }}
            />
          ) : (
            <Layer
              type="fill"
              paint={{
                "fill-color": highlight_color,
                "fill-opacity": 0.5,
                "fill-outline-color": highlight_color,
              }}
            />
          )}
        </Source>
      )}
    </>
  );
};

export { HandleFeatureHover, ShadeObjectHover };

// const HandleFeatureHover = () => {
//   const { current: mapRef } = useMap();
//   const map = mapRef.getMap();
//   const draw = useMapboxDraw();
//   const cur_hover_id = useSelector((state) => state.inputs.cur_hover_id);
//   let prev_hover_id = usePrevious(cur_hover_id); // Use a ref to store the previous hover id

//   //   useEffect(() => {
//   //     console.log("curent id", cur_hover_id);
//   //     console.log("prev id", prev_hover_id);
//   //   }, [cur_hover_id]);

//   useEffect(() => {
//     if (!map || !draw || !cur_hover_id) return;

//     // Unhighlight the previously highlighted feature
//     if (prev_hover_id && prev_hover_id !== cur_hover_id) {
//       const prevFeature = draw.get(prev_hover_id);
//       if (prevFeature) {
//         draw.setFeatureProperty(prev_hover_id, "highlight", false);
//       }
//     }

//     // Highlight the currently hovered feature
//     const currentFeature = draw.get(cur_hover_id);
//     if (currentFeature) {
//       draw.setFeatureProperty(cur_hover_id, "highlight", true);
//     }

//     // Update the previous hover ID ref
//     prev_hover_id = cur_hover_id;
//   }, [cur_hover_id, prev_hover_id, map, draw]); // Run this effect when cur_hover_id changes

//   return null; // No rendering needed for this component
// };

// export { HandleFeatureHover };
